var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mail-compose" },
    [
      _vm.showHeader
        ? _c("div", { staticClass: "compose-header" }, [
            _c("div", { staticClass: "compose-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.composeTitleText))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "compose-actions" },
              [
                _c("SupsisButton", {
                  attrs: { icon: "close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "compose-form" }, [
        _vm.enabledSelectSender
          ? _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("mail.From")) + ":"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("MailSelector", {
                    attrs: {
                      value: _vm.selectedFrom,
                      options: _vm.fromOptions,
                      placeholder: _vm.$t("mail.From"),
                      multiple: false,
                      showWarningForMultiple: false,
                      "auto-focus": _vm.autoFocusTo === "from",
                    },
                    on: {
                      input: _vm.handleFromChange,
                      search: function ($event) {
                        return _vm.handleMailSearch($event, "from")
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("mail.To")) + ":"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c("MailSelector", {
                attrs: {
                  value: _vm.formData.toList,
                  options: _vm.toOptions,
                  placeholder: _vm.$t("mail.recipientEmailAddress"),
                  multiple: true,
                  showWarningForMultiple: true,
                  "auto-focus": _vm.autoFocusTo === "to",
                },
                on: {
                  input: _vm.handleToChange,
                  search: function ($event) {
                    return _vm.handleMailSearch($event, "to")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cc-bcc-actions" },
            [
              _c(
                "SupsisButton",
                {
                  staticClass: "mini-btn",
                  attrs: { primary: _vm.showCc },
                  on: {
                    click: function ($event) {
                      _vm.showCc = !_vm.showCc
                    },
                  },
                },
                [_vm._v(" CC")]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  staticClass: "mini-btn",
                  attrs: { primary: _vm.showBcc },
                  on: {
                    click: function ($event) {
                      _vm.showBcc = !_vm.showBcc
                    },
                  },
                },
                [_vm._v(" BCC")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.showCc
          ? _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [_vm._v("CC:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("MailSelector", {
                    attrs: {
                      value: _vm.formData.ccList,
                      options: _vm.ccOptions,
                      placeholder: _vm.$t("mail.CCreceivers"),
                      multiple: true,
                    },
                    on: {
                      input: _vm.handleCcChange,
                      search: function ($event) {
                        return _vm.handleMailSearch($event, "cc")
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showBcc
          ? _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [_vm._v("BCC:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("MailSelector", {
                    attrs: {
                      value: _vm.formData.bccList,
                      options: _vm.bccOptions,
                      placeholder: _vm.$t("mail.BCCreceivers"),
                      multiple: true,
                    },
                    on: {
                      input: _vm.handleBccChange,
                      search: function ($event) {
                        return _vm.handleMailSearch($event, "bcc")
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isReply && !_vm.isForward
          ? _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("message.subject"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.subject,
                      expression: "formData.subject",
                    },
                  ],
                  ref: "mailSubject",
                  staticClass: "subject-input custom-input",
                  attrs: { placeholder: _vm.$t("mail.emailSubject") },
                  domProps: { value: _vm.formData.subject },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "subject", $event.target.value)
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.askForSignature && _vm.mailSignature && _vm.mailSignature.html
          ? _c("div", { staticClass: "signature-prompt" }, [
              _c("div", { staticClass: "signature-message" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("mail.signatureMessage")))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "signature-actions" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          _vm.askForSignature = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chatbotv2.no")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { small: "", primary: "" },
                      on: { click: _vm.addSignatureAndClosePrompt },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("chatbotv2.yes")) + "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "editor-container" },
          [
            _c("MailEditor", {
              ref: "mailEditor",
              attrs: { "auto-focus": _vm.autoFocusTo === "editor" },
              on: {
                "image-upload": _vm.handleImageUpload,
                "ai-assistant": _vm.onAIAssistant,
              },
              model: {
                value: _vm.formData.body,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "body", $$v)
                },
                expression: "formData.body",
              },
            }),
            _vm._v(" "),
            _c("input", {
              ref: "imageFileInput",
              staticStyle: { display: "none" },
              attrs: { type: "file" },
              on: { change: _vm.onImageFileSelected },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.formData.attachments.length > 0
          ? _c("div", { staticClass: "form-attachments" }, [
              _c("div", { staticClass: "attachments-title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("mail.emailAttachments", {
                        count: _vm.formData.attachments.length,
                      })
                    ) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "attachments-list" },
                _vm._l(_vm.formData.attachments, function (attachment, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "attachment-item" },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(_vm._s(_vm.getAttachmentIcon(attachment.name))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "attachment-info" }, [
                        _c("div", { staticClass: "attachment-name" }, [
                          _vm._v(_vm._s(attachment.name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "attachment-size" }, [
                          _vm._v(_vm._s(attachment.size)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("SupsisButton", {
                        attrs: { icon: "close", xxsmall: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeAttachment(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "compose-actions-bar" },
          [
            _c(
              "SupsisButton",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("mail.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { primary: "", disabled: !_vm.canSend },
                on: { click: _vm.sendMail },
              },
              [_vm._v(" " + _vm._s(_vm.$t("message.send")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showAIAssistant
        ? _c("MailAIAssistant", {
            attrs: {
              "mail-content": _vm.formData.body,
              "mail-details": _vm.mailDetails,
              threadMails: _vm.threadMails,
            },
            on: {
              close: function ($event) {
                _vm.showAIAssistant = false
              },
              "update-content": _vm.updateMailContent,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }